import _ from 'lodash';
import { getUrlParams, redirectToExternalUrl } from 'helpers/RouteHelper';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setCookie,
  setLocalStorageItem,
} from 'helpers/Storage';
import { isSSARedirect } from './ConfigHelper';

const ACTIVATE_CODE_EXPIRES_MINUTES = 30;
const COOKIE_ACTIVATE_ACCOUNT = 'ACTIVATE_ACCOUNT';
const COOKIE_ACTIVATE_CODE = 'ACTIVATE_CODE';
const getSharedCookieDomain = () => _.get(window.ExternalConfig, 'secondScreen.sharedCookieDomain');

// Change this to ''http://dev.go.fox.com:8000/ or 'http://dev.activate.fox.com:8080' if you want to test second screen locally
const getActivateRedirectUrl = () =>
  isSSARedirect()
    ? _.get(window.ExternalConfig, 'secondScreen.goActivateRedirectUrl') ||
      'http://dev.go.fox.com:8000/'
    : _.get(window.ExternalConfig, 'secondScreen.activateRedirectUrl');

const getCookieOptions = () => {
  const now = new Date().getTime();
  const expires = new Date(now + ACTIVATE_CODE_EXPIRES_MINUTES * 60 * 1000);
  const domain = getSharedCookieDomain();
  return { path: '/', domain, expires };
};

export const setActivateCode = value => setLocalStorageItem({ key: COOKIE_ACTIVATE_CODE, value });

export const getActivateCodeFromURL = () => {
  const { code } = getUrlParams(window.location.href);
  return code;
};

export const setActivateCodeAccount = account => {
  if (!account) return;
  const { accessToken, isNew } = account || {};
  const value = JSON.stringify({ accessToken, isNew });
  const options = getCookieOptions();
  setCookie({ name: COOKIE_ACTIVATE_ACCOUNT, value, options });
};

export const getActivateCode = () => getLocalStorageItem({ key: COOKIE_ACTIVATE_CODE });

export const redirectToActivateMVPD = code => {
  if (!code) return null;
  const activateUrl = getActivateRedirectUrl();
  removeLocalStorageItem({ key: COOKIE_ACTIVATE_CODE });
  const url = `${activateUrl}/account-success`;
  return redirectToExternalUrl(url);
};
